import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaSuitcase } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";

import "./card.css";

import { API_URL } from "../../../../api";
import { useCookies } from "../../../../hooks/useCookies";
import Button from "../../../userflow/components/button/Button";
import IconButton from "../../../userflow/components/card/IconButton";
import ProfileDetails from "../../../userflow/components/card/ProfileDetails";
import { getProfileImageUrl } from "../../../../utils/serverUtils";

export default function Card({ activeTabs, show, ...props }) {
  const navigate = useNavigate();
  const image = getProfileImageUrl(props);

  const cardRef = useRef(null);
  const [liked, setLiked] = useState(props.like);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [topNavVisible, setTopNavVisible] = useState(true);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  useEffect(() => {
    const bottomNav = document.querySelector("#bottomOptions");
    if (!bottomNav) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        setTopNavVisible(entry.isIntersecting);
      });
    });
    observer.observe(bottomNav);
  }, []);

  async function handleIconButtonClick(type) {}

  const capitalizeFirstLetter = input => {
    const string = String(input); // Convert the input to a string
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  return (
    <>
      <UpgradeModal show={showUpgradeModal} setShow={setShowUpgradeModal} />
      <ReportModal
        show={showReportModal}
        setShow={setShowReportModal}
        personId={props.user_id}
      />
      <BlockModal
        show={showBlockModal}
        setShow={setShowBlockModal}
        personId={props.user_id}
      />
      <div className="card-and-details-container">
        <div
          ref={cardRef}
          className={`card-container ${show ? "show" : ""}`}
          style={{
            backgroundImage: `
                            linear-gradient(0.05deg, #000000 -1.48%, rgba(0, 0, 0, 0.1) 29.79%, rgba(0, 0, 0, 0) 99.96%),
                            url(${image})
                        `,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            borderRadius: "8px",
          }}
        >
          <div
            className="details-container"
            style={{
              width: "100%",
            }}
          >
            <div
              className="details"
              style={{ marginLeft: "1rem", marginBottom: "1rem" }}
            >
              <p
                style={{
                  marginBottom: "-10px",
                }}
              >
                {" "}
                <span
                  style={{
                    fontSize: "32px",
                    fontWeight: "600",
                    lineHeight: "48px",
                  }}
                >
                  {capitalizeFirstLetter(props.first_name)}
                </span>
                ,{" "}
                <span
                  style={{
                    fontSize: "32px",
                    fontWeight: "300",
                    lineHeight: "48px",
                  }}
                >
                  {dayjs().diff(props.birthday, "y")}
                </span>
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "0.5rem",
                  marginBottom: "-10px",
                }}
              >
                <FaSuitcase size={25} />
                <p
                  style={{
                    fontSize: "medium",
                  }}
                >
                  {props.job}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "0.5rem",
                }}
              >
                <FaLocationDot size={25} />
                <p
                  style={{
                    fontSize: "medium",
                  }}
                >
                  {props.location_string
                    ? `${props.location_string}, ${props.country}`
                    : `${props.country}`}
                </p>
              </div>
            </div>
            <div
              style={{
                opacity: !topNavVisible ? "1" : "0",
              }}
            >
              <IconButton
                type="skip"
                onClick={e => {
                  e.stopPropagation();
                  handleIconButtonClick("skip");
                }}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "center",
                }}
              >
                <IconButton
                  type="chat"
                  onClick={e => {
                    e.stopPropagation();
                    handleIconButtonClick("chat");
                  }}
                />
                <IconButton
                  type={liked ? "likeActive" : "like"}
                  onClick={e => {
                    e.stopPropagation();
                    setLiked(!liked);
                    handleIconButtonClick("like");
                  }}
                />
              </div>
            </div>
          </div>
          <div
            className="menu"
            style={{
              flexDirection: "row !important",
              justifyContent: "space-between",
              width: "93%",
            }}
          >
            {window.location.pathname.endsWith(props.user_id) ? (
              <div
                onClick={e => {
                  e.stopPropagation();
                  window.history.back();
                }}
                style={{ cursor: "pointer" }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 12L20 12M4 12L10 6M4 12L10 18"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            ) : (
              <div></div>
            )}

            <Dropdown
              show={showDropdown}
              onToggle={() => setShowDropdown(!showDropdown)}
              onMouseEnter={() => setShowDropdown(true)}
              onMouseLeave={() => setShowDropdown(false)}
              onClick={e => {
                e.stopPropagation();
                navigate("/user/preferences");
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <Dropdown.Toggle as="div">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 5L10 5M10 5C10 6.10457 10.8954 7 12 7C13.1046 7 14 6.10457 14 5M10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5M14 5L20 5M4 12H16M16 12C16 13.1046 16.8954 14 18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12ZM8 19H20M8 19C8 17.8954 7.10457 17 6 17C4.89543 17 4 17.8954 4 19C4 20.1046 4.89543 21 6 21C7.10457 21 8 20.1046 8 19Z"
                    stroke="#4B164C"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  backdropFilter: "blur(10px)",
                  border: "none",
                }}
              >
                <Dropdown.Item
                  as="button"
                  className="dropdown-hover-button"
                  style={{
                    color: "white",
                  }}
                  onClick={e => {
                    e.stopPropagation();
                    navigate("/user/preferences");
                  }}
                >
                  Preferences
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div>
          <ProfileDetails
            userId={props.user_id}
            handleIconButtonClick={handleIconButtonClick}
            liked={liked}
            setLiked={setLiked}
            activeTabs={activeTabs}
          />
        </div>
      </div>
    </>
  );
}

function ReportModal({ show, setShow, personId }) {
  const cookies = useCookies();
  const [options, setOptions] = useState([]);
  const formRef = useRef(null);

  useEffect(() => {
    (async () => {
      const response = await fetch(
        `${API_URL}customer/matches/report-reasons`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookies.getCookie("token")}`,
          },
        }
      );
      const data = await response.json();
      if (response.ok) {
        setOptions(data);
      }
    })();
  }, [show, cookies]);

  async function report(e) {
    e.preventDefault();
    const response = await fetch(`${API_URL}customer/matches/report`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${cookies.getCookie("token")}`,
      },
      body: JSON.stringify({
        personId: personId,
        ...Object.fromEntries(new FormData(formRef.current)),
      }),
    });
    if (response.ok) {
      window.location.reload();
    }
  }

  return (
    <Modal
      className="customer-modal-without-header-footer"
      size="sm"
      centered
      show={show}
    >
      <Modal.Body>
        <p
          style={{
            fontSize: "large",
            fontWeight: "600",
            margin: "0",
            marginBottom: "1rem",
            color: "#6c6c6c",
          }}
        >
          Report user?
        </p>
        <p
          style={{
            fontSize: "14px",
            margin: "0",
            textAlign: "center",
            color: "#6c6c6c",
          }}
        >
          Report this user for violating MTD's community guidelines. Please
          select a reason for reporting the user below to help us improve your
          experience.
        </p>
        <form
          ref={formRef}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            marginBlock: "1rem",
          }}
          onSubmit={report}
        >
          {options.map(option => (
            <label
              key={option.id}
              htmlFor={option.id}
              style={{
                display: "flex",
                gap: "1rem",
                alignItems: "center",
                justifyContent: "flex-start",
                fontSize: "14px",
                textAlign: "left",
                color: "#6c6c6c",
              }}
            >
              <input
                type="radio"
                name="reportId"
                id={option.id}
                value={option.id}
                style={{
                  accentColor: "#4E1173",
                  width: "20px",
                  height: "20px",
                }}
              />
              <span>{option.name}</span>
            </label>
          ))}
        </form>
        <div
          style={{
            marginTop: "1rem",
            display: "flex",
            gap: "1rem",
            marginInline: "auto",
          }}
        >
          <button
            type="button"
            style={{
              borderRadius: "9999px",
              padding: "0.75rem 1.5rem",
              border: "2px solid #6c6c6c",
              color: "#6c6c6c",
              backgroundColor: "transparent",
            }}
            onClick={() => setShow(false)}
          >
            Close
          </button>
          <Button
            type="submit"
            style={{
              borderRadius: "9999px",
              padding: "0.75rem 1.5rem",
            }}
            onClick={() => formRef.current?.requestSubmit()}
          >
            Submit
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

function BlockModal({ show, setShow, personId }) {
  const cookies = useCookies();

  async function block() {
    const response = await fetch(`${API_URL}customer/matches/block`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${cookies.getCookie("token")}`,
      },
      body: JSON.stringify({
        personId: personId,
      }),
    });
    if (response.ok) {
      window.location.reload();
    }
  }

  return (
    <Modal size="sm" centered show={show}>
      <Modal.Body>
        <p
          style={{
            fontSize: "large",
            fontWeight: "600",
            margin: "0",
            marginBottom: "1rem",
            color: "#6c6c6c",
          }}
        >
          Block user
        </p>
        <p
          style={{
            fontSize: "14px",
            margin: "0",
            textAlign: "center",
            color: "#6c6c6c",
          }}
        >
          Blocked members will no longer be able to message you and won't show
          up when you're browsing
        </p>
        <div
          style={{
            marginTop: "1rem",
            display: "flex",
            gap: "1rem",
            marginInline: "auto",
          }}
        >
          <button
            type="button"
            style={{
              borderRadius: "9999px",
              padding: "0.75rem 1.5rem",
              border: "2px solid #6c6c6c",
              color: "#6c6c6c",
              backgroundColor: "transparent",
            }}
            onClick={() => setShow(false)}
          >
            Close
          </button>
          <Button
            onClick={block}
            style={{
              borderRadius: "9999px",
              padding: "0.75rem 1.5rem",
            }}
          >
            Submit
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

function UpgradeModal({ show, setShow }) {
  return (
    <Modal
      className="customer-modal-without-header-footer"
      size="sm"
      centered
      show={show}
    >
      <Modal.Body
        style={{
          position: "relative",
          padding: "1rem",
        }}
      >
        <span
          style={{
            position: "absolute",
            top: "-7px",
            right: "-7px",
          }}
          onClick={() => {
            setShow(false);
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="white" />
            <path
              d="M16 8L8 16M8.00001 8L16 16"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19 5L5 19M5.00001 5L19 19"
              stroke="#5E5E5E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <p
          style={{
            fontSize: "large",
            fontWeight: "500",
            margin: "0",
            marginBottom: "1rem",
            color: "#6c6c6c",
          }}
        >
          You can undo matches that you've passed on if you change your mind.
        </p>
        <div
          style={{
            marginTop: "1rem",
            display: "flex",
            gap: "1rem",
            marginInline: "auto",
          }}
        >
          <Button
            onClick={() => window.location.assign("/selectplan")}
            style={{
              borderRadius: "9999px",
              padding: "0.75rem 1.5rem",
            }}
          >
            Upgrade now
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
